export default {
	APPROVED: 'P',
	REJECTED: 'R'
};
